import { saveClicked, saveVisited } from './links.js'


document.addEventListener('DOMContentLoaded', () => {
  saveClicked()
  saveVisited()

  prepareQuiz()
  const swiperFunc = setSwiperScene();
  
  const uwb = new UWB({
    uaTabletViewport: {
      init: true,
      width: 1140,
    },
    toolStyleVariable100vh: {
      init: true,
      elementId: 'uw-styleVariable-100vh',
      variableName: '--js100vh', // CSS変数名
    },
    toolFixedHorizontalScroll: false,
  });
  UWX.ScrollLock('.ch-quiz');
});

const setSwiperScene = () => {
  return new Swiper('.sliderScene', {
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    centeredSlides : true,
    autoplay: {
      delay: 10000,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}

const contQ = document.querySelectorAll('.ch-quiz-content.question')
const contA = document.querySelectorAll('.ch-quiz-content.answer')
const prepareQuiz = () =>  {
  Array.from(document.querySelectorAll('.active')).forEach((el) => {
    el.classList.remove('active')
  })
  updateNumber(0)
  handlersQuiz()

  Array.from(document.querySelectorAll('.ch-btn_quiz')).forEach(btn => {
    btn.addEventListener('click', (e) => {
      document.querySelector('.ch-quiz').classList.add('active')
      document.querySelector('.ch-quiz-inner').classList.add('active')

      contQ[0].classList.add('active')

      e.stopPropagation()

      document.addEventListener('click', handlerQuizOuter)
    })
  })
}

const handlerQuizOuter = (e) => {
  const inner = Array.from(e.path).findIndex(p => {
    if(p.classList){
      return p.classList.contains('ch-quiz-inner')
    }else{
      return false
    }
  })
  if(inner < 0){
    document.removeEventListener('click', handlerQuizOuter)
    document.querySelector('.btn-quiz_close').click()
  }
}

const handlersQuiz = () => {
  //Q
  Array.from(contQ).forEach((qel, qi) => {
    if(0 < qi) {
      qel.querySelector('.btn-quiz_prev').addEventListener('click', () => {
        contQ[qi].classList.remove('active')
        Array.from(contQ[qi].querySelectorAll('.active')).forEach((el) => {
          el.classList.remove('active')
        })
        contQ[qi - 1].classList.add('active')
        Array.from(contA[qi - 1].querySelectorAll('.active')).forEach((el) => {
          el.classList.remove('active')
        })
        updateNumber(qi - 1)
      })
    }

    qel.querySelector('.ch-quiz-button .right').addEventListener('click', () => {
      contQ[qi].classList.remove('active')
      contA[qi].classList.add('active')
      contA[qi].querySelector('.ch-quiz-result.correct').classList.add('active')
      contA[qi].querySelector('.chara.happy').classList.add('active')
    })
    qel.querySelector('.ch-quiz-button .wrong').addEventListener('click', () => {
      contQ[qi].classList.remove('active')
      contA[qi].classList.add('active')
      contA[qi].querySelector('.ch-quiz-result.incorrect').classList.add('active')
      contA[qi].querySelector('.chara.sad').classList.add('active')
    })
  })

  //A
  Array.from(contA).forEach((ael, ai) => {
    ael.querySelector('.btn-quiz_next').addEventListener('click', () => {
      contA[ai].classList.remove('active')

      if(ai < contQ.length - 1){
        updateNumber(ai + 1)
        contQ[ai + 1].classList.add('active')
      }else{
        document.querySelector('.ch-quiz-content.result').classList.add('active')
        const corrects = document.querySelectorAll('.ch-quiz-result.correct.active')
        document.querySelector('.ch-quiz-content.result .ch-quiz-result span').innerText = `${corrects.length}`
      }
    })
  })

  //end close
  document.querySelector('.btn-quiz_end').addEventListener('click', () => {
    document.querySelector('.btn-quiz_reset').click()
  })

  //close
  document.querySelector('.btn-quiz_close').addEventListener('click', (e) => {
    document.querySelector('.ch-quiz-inner').classList.remove('active')
    document.querySelector('.ch-quiz-menu').classList.add('active')
    document.querySelector('.btn-quiz_reset').classList.add('active')
    document.querySelector('.btn-quiz_return').classList.add('active')
  })

  //menu reset
  document.querySelector('.btn-quiz_reset').addEventListener('click', () => {
    Array.from(document.querySelectorAll('.active')).forEach((el) => {
      el.classList.remove('active')
    })
    updateNumber(0)
  })

  //menu return
  document.querySelector('.btn-quiz_return').addEventListener('click', (e) => {
    document.querySelector('.ch-quiz-menu').classList.remove('active')
    document.querySelector('.btn-quiz_reset').classList.remove('active')
    document.querySelector('.btn-quiz_return').classList.remove('active')
    document.querySelector('.ch-quiz-inner').classList.add('active')

    e.stopPropagation()
    document.addEventListener('click', handlerQuizOuter)
  })
}

const updateNumber = (num) => {
  document.querySelector('.ch-quiz-inner .number span').innerText = `${num + 1}`
}
